export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-white/80">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-gray-500 sm:flex-row sm:px-6 lg:px-8">
        <span>© {year} Conciergie. All rights reserved.</span>
        <a
          href="/privacy-policy"
          className="underline-offset-4 hover:text-gray-700 hover:underline"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}


